const provisionerQueryKey = ['provisioner'];
export default provisionerQueryKey;
